import { render, staticRenderFns } from "./MembershipListItem.vue?vue&type=template&id=54f4f27a&scoped=true"
import script from "./MembershipListItem.vue?vue&type=script&lang=ts"
export * from "./MembershipListItem.vue?vue&type=script&lang=ts"
import style0 from "./MembershipListItem.vue?vue&type=style&index=0&id=54f4f27a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f4f27a",
  null
  
)

export default component.exports